/* eslint-disable react-hooks/exhaustive-deps */
// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopicFlow from './components/TopicFlow';
import HomeScreen from './components/HomeScreen';
import { UserProvider } from './context/UserContext'; // Import the UserProvider
import './styles/App.css';
import NotFound404 from './components/NotFound404';

function App() {
  return (
    <UserProvider>
      <Router>
        <div className="App" style={{ width: '100vw', height: '100vh' }}>
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/explore" element={<TopicFlow />} />
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;
